'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _Day = require('./Day');

var _Day2 = _interopRequireDefault(_Day);

var _DayOfWeek = require('./DayOfWeek');

var _DayOfWeek2 = _interopRequireDefault(_DayOfWeek);

var _Week = require('./Week');

var _Week2 = _interopRequireDefault(_Week);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
    displayName: 'Calendar',


    propTypes: {
        onSelect: _react2.default.PropTypes.func.isRequired,
        date: _react2.default.PropTypes.object,
        month: _react2.default.PropTypes.object,
        dayClasses: _react2.default.PropTypes.func,
        useNav: _react2.default.PropTypes.bool,
        locale: _react2.default.PropTypes.string,
        startOfWeekIndex: _react2.default.PropTypes.number,
        dayRenderer: _react2.default.PropTypes.func
    },

    getDefaultProps: function getDefaultProps() {
        return {
            month: (0, _moment2.default)(),
            dayClasses: function dayClasses() {
                return [];
            },
            useNav: true,
            locale: 'en',
            startOfWeekIndex: 0
        };
    },
    getInitialState: function getInitialState() {
        var date = this.props.date;
        var month = void 0;
        if (date) {
            month = this.props.date;
        } else {
            month = this.props.month;
        }
        return {
            date: date,
            month: month
        };
    },
    componentWillMount: function componentWillMount() {
        _moment2.default.locale(this.props.locale);

        if (!!this.state.date) {
            this.state.date.locale(this.props.locale);
        }

        this.state.month.locale(this.props.locale);
    },
    componentWillUpdate: function componentWillUpdate(nextProps, nextState) {
        _moment2.default.locale(this.props.locale);

        if (!!nextState.date) {
            nextState.date.locale(this.props.locale);
        }

        nextState.month.locale(this.props.locale);
    },
    handleClick: function handleClick(date) {
        var flag = this.props.onSelect(date, this.state.date, this.state.month);

        if (flag === true) {
            this.setState({
                date: (0, _moment2.default)(date)
            });
        } else if (flag === false) {
            this.setState({
                date: null
            });
        }
    },
    previous: function previous() {
        this.setState({
            month: (0, _moment2.default)(this.state.month).subtract(1, 'month')
        });
    },
    next: function next() {
        this.setState({
            month: (0, _moment2.default)(this.state.month).add(1, 'month')
        });
    },
    render: function render() {
        var _props = this.props,
            startOfWeekIndex = _props.startOfWeekIndex,
            dayRenderer = _props.dayRenderer;


        var classes = ['Calendar', this.props.className].join(' ');

        var today = (0, _moment2.default)();

        var date = this.state.date;
        var month = this.state.month;

        var current = month.clone().startOf('month').day(startOfWeekIndex);
        if (current.date() > 1 && current.date() < 7) {
            current.subtract(7, 'd');
        }

        var end = month.clone().endOf('month').day(7 + startOfWeekIndex);
        if (end.date() > 7) {
            end.subtract(7, 'd');
        }

        var elements = [];
        var days = [];
        var week = 1;
        var i = 1;
        var daysOfWeek = [];
        var day = current.clone();
        for (var j = 0; j < 7; j++) {
            var dayOfWeekKey = 'dayOfWeek' + j;
            daysOfWeek.push(_react2.default.createElement(_DayOfWeek2.default, { key: dayOfWeekKey, date: day.clone() }));
            day.add(1, 'days');
        }
        while (current.isBefore(end)) {
            var dayClasses = this.props.dayClasses(current);
            if (!current.isSame(month, 'month')) {
                dayClasses = dayClasses.concat(['other-month']);
            }
            var isCurrentMonth = current.isSame(month, 'month');
            var props = {
                date: current.clone(),
                selected: date,
                month: month,
                today: today,
                classes: dayClasses,
                handleClick: this.handleClick
            };

            var children = void 0;
            if (!!dayRenderer) {
                children = dayRenderer(props);
            }

            days.push(_react2.default.createElement(
                _Day2.default,
                _extends({ key: i++ }, props),
                children
            ));
            current.add(1, 'days');
            if (current.day() === startOfWeekIndex) {
                var weekKey = 'week' + week++;
                elements.push(_react2.default.createElement(
                    _Week2.default,
                    { key: weekKey },
                    days
                ));
                days = [];
            }
        }

        var nav = void 0;

        if (this.props.useNav) {
            nav = _react2.default.createElement(
                'tr',
                { className: 'month-header' },
                _react2.default.createElement(
                    'th',
                    { className: 'nav previous' },
                    _react2.default.createElement(
                        'button',
                        { className: 'nav-inner', onClick: this.previous, type: 'button' },
                        '\xAB'
                    )
                ),
                _react2.default.createElement(
                    'th',
                    { colSpan: '5' },
                    _react2.default.createElement(
                        'span',
                        { className: 'month' },
                        month.format('MMMM')
                    ),
                    ' ',
                    _react2.default.createElement(
                        'span',
                        { className: 'year' },
                        month.format('YYYY')
                    )
                ),
                _react2.default.createElement(
                    'th',
                    { className: 'nav next' },
                    _react2.default.createElement(
                        'button',
                        { className: 'nav-inner', onClick: this.next, type: 'button' },
                        '\xBB'
                    )
                )
            );
        } else {
            nav = _react2.default.createElement(
                'tr',
                { className: 'month-header' },
                _react2.default.createElement(
                    'th',
                    { colSpan: '7' },
                    _react2.default.createElement(
                        'span',
                        { className: 'month' },
                        month.format('MMMM')
                    ),
                    ' ',
                    _react2.default.createElement(
                        'span',
                        { className: 'year' },
                        month.format('YYYY')
                    )
                )
            );
        }

        return _react2.default.createElement(
            'table',
            { className: classes },
            _react2.default.createElement(
                'thead',
                null,
                nav
            ),
            _react2.default.createElement(
                'thead',
                null,
                _react2.default.createElement(
                    'tr',
                    { className: 'days-header' },
                    daysOfWeek
                )
            ),
            _react2.default.createElement(
                'tbody',
                null,
                elements
            )
        );
    }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-calendar-pane/lib/Calendar.js
// module id = 1032
// module chunks = 0